import { Navigate, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../contexts/AuthContext'

export default function AuthGuard({ children }: { children: ReactNode }) {
  const auth = useAuth()
  const location = useLocation()
  const { t } = useTranslation('common')

  if (auth.status === 'loading') {
    return (
      <div className="min-h-screen grid place-items-center bg-[#0b1226] t-primary">
        <div className="flex items-center gap-3 t-muted">
          <Loader2 size={20} className="animate-spin text-jr2-400" />
          <span>{t('loading')}</span>
        </div>
      </div>
    )
  }

  if (auth.status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  return <>{children}</>
}
